import { CallToAction, Header, Heading, List, TextAndMedia } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next/pages'
import StartSimulationButton from 'components/start-simulation-button/StartSimulationButton'
import styles from './UspsFun.module.scss'
import { I18nUSP } from 'types/i18n'
import UspTestimonials from 'features/usps/components/testimonials/UspTestimonials'

const UspsFun = () => {
  // i18n
  const { t } = useTranslation('usps', { keyPrefix: 'fun' })

  return (
    <main>
      <Header title={t('header.title')} color="accent-warm" shape="s6">
        <p>{t('header.description')}</p>
      </Header>

      <TextAndMedia
        title={t('intro.title')}
        media={{
          type: 'image',
          imageBehaviour: '1-1',
          props: { publicId: '/website/usps/fun', fill: true, alt: '' }
        }}
      >
        <p>{t('intro.description')}</p>
        <div className="flex-col gap-100">
          <Heading as="h3" variant="h4" serif>
            {t('intro.subtitle')}
          </Heading>
          <p>{t('intro.festivals')}</p>
        </div>
      </TextAndMedia>

      <TextAndMedia
        inverse
        title={t('extra.title')}
        media={{
          type: 'image',
          imageBehaviour: '3-4',
          props: { publicId: '/website/usps/how-it-works', fill: true, alt: '' }
        }}
      >
        <List as="ul" bullets="badgeCheck" className={styles.extras}>
          {(t('extra.bullets', { returnObjects: true }) as Omit<I18nUSP, 'key'>[]).map(({ title, description }, index) => (
            <li className={styles.bullet} key={`extra-${index}`}>
              <div className={styles['bullet-wrapper']}>
                <strong className="h4 serif">{title}</strong>
                <p>{description}</p>
              </div>
            </li>
          ))}
        </List>
      </TextAndMedia>

      <CallToAction title={t('cta.title')} color="dark" shape="s6" action={<StartSimulationButton />}>
        <p>{t('cta.description')}</p>
      </CallToAction>

      <UspTestimonials
        reviews={t('testimonials.reviews', { returnObjects: true }) as Array<{ text: string; author: string; job: string }>}
      />
    </main>
  )
}

export default UspsFun
